import React, { Component } from 'react';
//import addNotification from 'react-push-notification';
//import { Notifications } from 'react-push-notification';
import { requestBase, apiroot } from "./Fetch-helpers";
import InputMask from 'react-input-mask';
//import NumberPicker from "react-widgets/NumberPicker";
import { InputNumber } from "primereact/inputnumber"
import "primereact/resources/themes/mira/theme.css"

import { showPopopMessage } from "../../Components/PopupMessage/Toastify.js";
import { TYPE_MESSAGE_EXCEEDS_LENGTH, TYPE_MESSAGE_WRONG_CASE, TYPE_MESSAGE_UNAVAILABLE_SYMBOL } from "../../Components/PopupMessage/Toastify.js";

export default class OptionItem extends Component {


    constructor(props) {
        super(props);

        //this.setStateConfiguration = props.setStateConfiguration
        this.dtNow = new Date();

        this.state = {
            //ncvalue: this.props.option.currentValue ? this.props.option.currentValue : this.props.option.defaultValue,

            waiting: false, posting: false,
            timerOn: false, timerDuration: 0, timerTime: 0, //valuefortimer: null,
        };
    }

    startTimer = (msDuration) => {
        this.setState({
            timerOn: true,
            timerTime: 0, //this.state.timerTime,
            timerDuration: msDuration //this.state.timerTime
        });
        this.timer = setInterval(() => {
            const newTime = this.state.timerTime + 10;
            if (newTime < this.state.timerDuration) {
                this.setState({
                    timerTime: newTime
                });
            } else {
                this.stopTimer();
                //alert("Countdown ended");
                //let val = this.validate(this.state.ncvalue);
                //this.setState({ ncvalue: val });

                let val = this.validate(this.props.option.currentValue);
                this.postData();
            }
        }, 10);
    };
    stopTimer = () => {
        clearInterval(this.timer);
        this.setState({ timerOn: false, timerTime: 0 });
    };
    resetTimer = () => {
        if (this.state.timerOn === true) {
            this.setState({
                timerTime: 0 //this.state.timerStart
            });
        }
    };

    updatePostingStatus(posting) {

        //if (posting) {
        //    this.dtNow = new Date();
        //} else {
        //    if (this.dtNow != undefined) {
        //        const diff = new Date() - this.dtNow;
        //        alert(diff);
        //    }
        //}

        this.props.updatePostingStatus(posting);
    }

    handleKeyDownNumeric(event) {
        if (event.key.length == 1 && "0123456789,.-".indexOf(event.key) === -1) {
            event.preventDefault();
            showPopopMessage("Необходимо ввести число!", TYPE_MESSAGE_UNAVAILABLE_SYMBOL);
            return;
        }

        //if (event.key.length == 1 && ",.".indexOf(event.key) != -1) {
        //    const currentValue = event.target.defaultValue;
        //    if (currentValue.indexOf('.') != -1 || currentValue.indexOf(',') != -1) {
        //        event.preventDefault();
        //        showPopopMessage("Необходимо ввести число!", TYPE_MESSAGE_UNAVAILABLE_SYMBOL);
        //        return;
        //    }
        //}

        //if (event.key.length == 1 && "-".indexOf(event.key) != -1) {
        //    const currentValue = event.target.defaultValue;
        //    // если '-' уже есть, и пытаются еще один ввести, то не даем
        //    if (currentValue.indexOf('-') != -1) {
        //        event.preventDefault();
        //        return;
        //    }
        //    // если пытаются ввести '-' не в начале числа, то не даем
        //    if (currentValue.length > 1 && event.target.selectionStart > 0) {
        //        event.preventDefault();
        //        return;
        //    }
        //}
    }

    render() {

        const option = this.props.option;
        const debug = this.props.debug;
        const enable = this.props.extDisable ? false : option.active;

        //Numeric
        let precision = 0;
        if (option.step) {
            const dotind = ('' + option.step).indexOf('.');
            precision = dotind > 0 ? ('' + option.step).length - dotind - 1 : 0;
        }
        //
        const ncvalue = this.props.option.currentValue ? this.props.option.currentValue : this.props.option.defaultValue;

        return (
            <tr>
                <td className={option.required ? "redOptFea redOptItemFea" : "fillOptItemFea"}></td>
                <td>
                    <div className="container">
                        <button
                            className={`${option.type !== "text" ? "" : "optionItemLeft"} optionItem ${enable ? "active " + (option.selected ? "selected" : "unselected") : "inactive"}`}

                            disabled={!enable}

                            onClick={this.onclickpostData}
                        >
                            {option.code} | {option.name} {" "}
                            {option.description} {option.currentValue ? "| " + option.currentValue : ""}
                            {debug ? "| selected=" + String(option.selected) + " active=" + String(option.active) + " activeNotRule=" + String(option.activeNotRule) : ""}
                        </button>
                        {option.type !== "text" ? "" :
                            <InputMask className="optionItemRight optionItem text-field__input" mask={option.mask} maskChar={null} placeholder={option.mask} defaultValue={option.currentValue} onBlur={ev => { this.fixtextData(ev.target.value) }} disabled={!enable}></InputMask>}

                        {option.type !== "numericUpDown" ? "" :

                            <InputNumber
                                showButtons
                                locale="ru-RU"

                                value={typeof ncvalue == "string" ? Number(ncvalue.toString().replace(',', '.')) : ncvalue}
                                max={!isNaN(parseFloat(option.max)) ? parseFloat(option.max) : null}
                                //min={parseFloat(option.min) ? parseFloat(option.min) : null}
                                step={!isNaN(parseFloat(option.step)) ? parseFloat(option.step) : 1}
                                onChange={e => this.changingValue(e.value)}
                                disabled={!enable}
                                onKeyDown={this.handleKeyDownNumeric}
                                minFractionDigits={precision}
                                //inputProps={{ title: `max:${option.max} min:${option.min} step:${option.step}` }}
                                tooltip={`min:${option.min} max:${option.max} step:${option.step} ${option.excludedValue ? " exluded:" + option.excludedValue:""}`}
                                tooltipOptions={{position:'bottom', showDelay:300, hideDelay:300}}
                            />

                            //<NumberPicker
                            //    value={typeof this.state.ncvalue == "string" ? Number(this.state.ncvalue.toString().replace(',', '.')) : this.state.ncvalue}
                            //    max={parseFloat(option.max) ? parseFloat(option.max) : null}
                            //    min={parseFloat(option.min) ? parseFloat(option.min) : null}
                            //    step={parseFloat(option.step) ? parseFloat(option.step) : 1}
                            //    precision={precision}
                            //    messages={{
                            //        increment: `Увеличить на ${option.step}`,
                            //        decrement: `Уменьшить на ${option.step}`,
                            //    }}
                            //    onChange={value => this.changingValue(value)}
                            //    //onBlur={this.fixData}
                            //    readOnly={!enable}
                            //    onKeyDown={this.handleKeyDownNumeric}
                            //    //parse={(strValue, localizer) => {
                            //    //    return localizer.parseNumber(strValue.replace('_', ''))
                            //    //}}
                            //    inputProps={{ title: `max:${option.max} min:${option.min} step:${option.step}` }}
                            ///>
                        }

                        {option.type !== "repeater" ? "" :
                            <InputNumber
                                showButtons
                                locale="ru-RU"

                                value={typeof ncvalue == "string" ? Number(ncvalue.toString().replace(',', '.')) : ncvalue}
                                max={parseFloat(option.max) ? parseFloat(option.max) : null}
                                //min={parseFloat(option.min) ? parseFloat(option.min) : null}
                                step={parseFloat(option.step) ? parseFloat(option.step) : 1}
                                minFractionDigits={precision}
                                onChange={e => this.changingValue(e.value)}
                                disabled={!enable}
                                onKeyDown={this.handleKeyDownNumeric}
                                inputProps={{ title: `min:${option.min} max:${option.max} step:${option.step} ${option.excludedValue ? " exluded:" + option.excludedValue : ""}` }}
                            />

                            //<NumberPicker
                            //    value={typeof this.state.ncvalue == "string" ? Number(this.state.ncvalue.toString().replace(',', '.')) : this.state.ncvalue}
                            //    max={parseFloat(option.max) ? parseFloat(option.max) : null}
                            //    min={parseFloat(option.min) ? parseFloat(option.min) : null}
                            //    step={parseFloat(option.step) ? parseFloat(option.step) : 1}
                            //    precision={precision}
                            //    messages={{
                            //        increment: `Увеличить на ${option.step}`,
                            //        decrement: `Уменьшить на ${option.step}`,
                            //    }}
                            //    onChange={value => this.changingValue(value)}
                            //    //onBlur={this.fixData}
                            //    readOnly={!enable}
                            //    onKeyDown={this.handleKeyDownNumeric}

                            //    inputProps={{ title: `max:${option.max} min:${option.min} step:${option.step}` }}
                            ///>
                        }

                    </div>
                </td>
            </tr>
        );
    }

    onclickpostData = () => {
        const option = this.props.option;
        if (option.type == "numericUpDown" || option.type == "repeater")
            option.selected = !option.selected;

        this.postData();
    }

    async postDataAsync() {

        const option = this.props.option;
        option.configurationId = this.props.configurationId;


        //const params = new Proxy(new URLSearchParams(window.location.search.toLowerCase()), {
        //    get: (searchParams, prop) => searchParams.get(prop),
        //})

        console.log("Выполняем PATCH для Configuration...");
        console.log("Значение: " + option.code + " (" + option.description + ")");
        try {
            let response = await fetch(apiroot + "Configuration" /*+ (params.cfgid == null ? "" : params.cfgid)*/,
                Object.assign({}, requestBase, {
                    method: "PATCH",
                    credentials: 'include',
                    headers: {
                        'Accept': 'application/json', //, text/plain
                        'Content-Type': 'application/json'//;charset=UTF-8
                    },
                    body: JSON.stringify(option)
                }));

            if (!response.ok) {

                switch (response.status) {
                    case 599:

                        console.log("Повторно Get Configuration...");
                        await this.props.updateConfiguration(undefined);

                        console.log("Повторно PATCH...");
                        response = await fetch(apiroot + "Configuration" /*+ (params.cfgid == null ? "" : params.cfgid)*/,
                            Object.assign({}, requestBase, {
                                method: "PATCH",
                                credentials: 'include',
                                headers: {
                                    'Accept': 'application/json', //, text/plain
                                    'Content-Type': 'application/json'//;charset=UTF-8
                                },
                                body: JSON.stringify(option)
                            }));

                        break;
                    default:
                        const data = await response.json();
                        console.log(JSON.stringify(data));
                        //this.updatePostingStatus(false);
                        //alert("Какая-то фигня! Смотри консоль...\nЕще можно нажать F5");
                        this.props.showError(JSON.stringify(data));
                        return;
                }

                //if (!response.ok) {
                //    const data = await response.json();
                //    console.log(JSON.stringify(data));
                //    //this.updatePostingStatus(false);
                //    return;
                //}
            }

            console.log("PATCH отработал нормально");

            const data = await response.json();
            //console.log(JSON.stringify(data));
            //this.setState({ Model: data, loading2: false });
            this.props.updateConfiguration(data, true, true, true);
            //this.setStateConfiguration (data)
            if (data.errorMessageString != null) {
                alert(data.errorMessageString);

                //    addNotification({
                //        title: 'Warning',
                //        native: true
                //    })
            }
        }
        catch (err) {
            this.props.showError(err);
        }

        this.updatePostingStatus(false);
    }

    async postDataAsyncTry() {
        try {
            this.props.handleLock(true);
            await this.postDataAsync();
        }
        finally {
            this.props.handleLock(false);
        }
    }

    postData = () => {

        /* Неактивная (недоступная для выбора) опция не должна "нажиматься" */
        if (!this.props.option.active) {
            return;
        }

        this.updatePostingStatus(true);

        this.postDataAsyncTry();

        //if (this.props.requiredFeature) {
        this.props.handleToggle();
        //}
    }

    validate = (cvalue) => {
        console.log(cvalue);
        let value = cvalue;
        const option = this.props.option;
        switch (option.type) {
            case "numericUpDown":
                const max = parseFloat(option.max) ? parseFloat(option.max) : null;
                const min = parseFloat(option.min) ? parseFloat(option.min) : null;
                const step = parseFloat(option.step) ? parseFloat(option.step) : 1;

                if (max && value > max)
                    value = max;
                else if (min && value < min)
                    value = min;
                else if (!step)
                    break;
                else {
                    let delt = max > min ? value - min : Math.abs(min + value);

                    if (delt % step != 0) {
                        let _add = Math.floor(delt / step);
                        if (delt % step >= step / 2)
                            _add++;

                        value = min + _add * step;
                    }
                }

                if (option.excludedValue)
                    if (option.excludedValue.includes(value))
                        value = option.defaultValue;

                option.currentValue = String(value);
                option.selected = true;
                //this.setState({ ncvalue: value });
                console.log("currentValue " + option.currentValue);
                break;
            case "repeater":
                const max_x = parseFloat(option.max) ? parseFloat(option.max) : null;
                const min_x = parseFloat(option.min) ? parseFloat(option.min) : null;
                const step_x = parseFloat(option.step) ? parseFloat(option.step) : 1;

                if (max_x && value > max_x)
                    value = max_x;
                else if (min_x && value < min_x)
                    value = min_x;
                else if (!step_x)
                    break;
                else {
                    let delt = max_x > min_x ? value - min_x : Math.abs(min_x + value);

                    if (delt % step_x != 0) {
                        let _add = Math.floor(delt / step_x);
                        if (delt % step_x >= step_x / 2)
                            _add++;

                        value = min_x + _add * step_x;
                    }
                }

                if (option.excludedValue)
                    if (option.excludedValue.includes(value))
                        value = option.defaultValue;

                option.currentValue = String(value);
                option.selected = true;
                break;
            default:
                option.currentValue = String(value);
                break;
        }

        return value;
    }

    //changeData = (cvalue) => {
    //    //let val = this.validate(cvalue);

    //    this.setState({
    //        ncvalue: cvalue
    //    });
    //    //const option = this.props.option;

    //    //if (!cvalue
    //    //    || option.currentValue === cvalue) return;

    //    //option.currentValue = cvalue;
    //}

    changingValue = (value) => {

        try {
            this.props.option.currentValue = String(value);
            /*let val = this.validate(value);*/
            //this.setState({ ncvalue: val, waiting: true });
            //this.setState({ ncvalue: value, valuefortimer: value });

            if (!this.state.timerOn) {
                this.startTimer(1000);
            } else {
                this.resetTimer();
            }
        } catch { }
    }

    //fixData = (value) => {        
    //    let val = this.validate(value);

    //    this.setState({
    //        ncvalue: val
    //    });

    //    //const option = this.props.option;
    //    //option.currentValue = val;

    //    this.postData();
    //}

    fixtextData = (cvalue) => {
        const option = this.props.option;

        if (!cvalue
            || option.currentValue === cvalue) return;

        option.currentValue = cvalue;

        this.postData();
    }

}